import React from "react";
import PropTypes from "prop-types";
import { Alert, Chip, Stack, Typography } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { SEVERITY_ORDER } from "./dashboardConstants";
import { POPPINS } from "./dashboardTypography";

const AlertsBanner = ({ summary }) => {
  if (!summary) return null;

  const chips = SEVERITY_ORDER.map((severity) => ({
    severity,
    count: summary?.severityBreakdown?.[severity] ?? 0,
  })).filter((item) => item.count > 0);

  return (
    <Alert
      icon={<WarningAmberRoundedIcon fontSize="inherit" />}
      severity={summary.criticalAlerts > 0 ? "error" : "warning"}
      sx={{ borderRadius: 2 }}
    >
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ xs: "flex-start", sm: "center" }}>
        <Typography variant="body2" sx={{ ...POPPINS, fontWeight: 600, fontSize: "0.8rem" }}>
          Active Alerts: {summary.totalActiveAlerts ?? "N/A"} | Critical: {summary.criticalAlerts ?? "N/A"}
        </Typography>
        <Stack direction="row" spacing={0.75}>
          {chips.map((item) => (
            <Chip
              key={item.severity}
              label={`${item.severity.toUpperCase()}: ${item.count}`}
              size="small"
              variant="outlined"
              sx={{ ...POPPINS, fontSize: "0.72rem", height: 24 }}
            />
          ))}
        </Stack>
      </Stack>
    </Alert>
  );
};

AlertsBanner.propTypes = {
  summary: PropTypes.shape({
    totalActiveAlerts: PropTypes.number,
    criticalAlerts: PropTypes.number,
    severityBreakdown: PropTypes.object,
  }),
};

AlertsBanner.defaultProps = {
  summary: null,
};

export default AlertsBanner;
